 const themePath = main_scripts.dist_path;

window.collections = {};

const SCRIPTS = [
    {
        'url' : main_scripts.slider,
        'sel' : '.swipe-container',
        'col' : 'slider'
    }
];

let selectors = [];
for (let script of SCRIPTS) {
    selectors.push(script.sel);
}

const obj_present = Array.from(document.querySelectorAll(selectors.join(',')));
for (let script of SCRIPTS) {
    collections[script.col] = obj_present.filter(item => item.matches(script.sel));
    if (collections[script.col].length > 0) {
        import(themePath + script.url)
            .catch(console.error)
        ;
    }
}